"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAnalyticsUser = exports.logger = void 0;
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const middlewareUtils_1 = require("./middlewareUtils");
exports.logger = middlewareUtils_1.loggerUtil();
exports.setAnalyticsUser = middlewareUtils_1.setAnalyticsUserUtil(mixpanel_browser_1.default);
